export const SNAPCHAT_PIXEL_ID = 'a12fc24a-8d12-4742-b2d7-4faeb5d03371';
